import { type DisplayDocument, Document } from '@startuptools/business-ui/document/Document';
import { useLingui } from '@lingui/react';
import { Stack } from '@startuptools/ui/Stack';
import { DocGenRelationName } from '@startuptools/common/doc-gen';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { apiClient } from '../../../../common/http';
import { useDeleteFileMutation } from '../../../../graphql/react-operations';
import { GqlDocSystemTagKind, type GqlMeeting } from '../../../../graphql/base-types.graphql';

export const MeetingSummonsCoverSheet = ({
  meeting,
  refetch,
}: {
  meeting: Pick<GqlMeeting, 'id'> & { latestSummonsCoverSheet?: DisplayDocument | null };
  refetch: () => void;
}) => {
  const companyId = useCompanyId();
  const { i18n } = useLingui();
  // eslint-disable-next-line sut/loading-mutation
  const [doDelete] = useDeleteFileMutation();

  return (
    <Stack>
      <Document
        defaultFileName={i18n._({ id: 'Upload Cover Sheet here' })}
        document={meeting.latestSummonsCoverSheet}
        allowDigitalSignature={false}
        upload={async ({ file }) => {
          const relation = {
            relation_id: meeting.id,
            relation_name: DocGenRelationName.MeetingId,
          };
          await apiClient.uploadFile(
            file,
            file.name,
            companyId,
            relation,
            false,
            GqlDocSystemTagKind.MeetingSummonsCoverSheet,
          );
          refetch();
        }}
        onDelete={async () => {
          const id = meeting.latestSummonsCoverSheet?.id;
          if (!id) {
            throw new Error('there is no cover sheet to delete');
          }
          await doDelete({ variables: { companyId, id } });
          refetch();
        }}
      />
    </Stack>
  );
};
